import React, { Component } from 'react';
import styled from 'styled-components';

const StyledSecondaryNav = styled.div`
  position: absolute;
  width: calc(100% - 60px);
  height: 44px;
  display: flex;
  justify-content: space-between;
  bottom: 260px;
`

class SecondaryNav extends Component {
  render = () => {
    return (
      <StyledSecondaryNav>
        
      </StyledSecondaryNav>
    )
  }
}

export default SecondaryNav;


// WEBPACK FOOTER //
// ./src/components/instore/SecondaryNav.js